import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

import type { Guide } from '../data/accommodation-guides';

const styles = StyleSheet.create({
  page: {
    padding: 48,
    fontFamily: 'Helvetica',
    backgroundColor: '#ffffff',
  },
  header: {
    borderBottom: '2pt solid #213570',
    paddingBottom: 12,
    marginBottom: 20,
  },
  brand: {
    fontSize: 14,
    fontFamily: 'Helvetica-Bold',
    color: '#213570',
    marginBottom: 4,
  },
  headerSubtext: {
    fontSize: 9,
    color: '#9ca3af',
  },
  title: {
    fontSize: 22,
    fontFamily: 'Helvetica-Bold',
    color: '#1f2937',
    marginBottom: 6,
  },
  situation: {
    fontSize: 11,
    color: '#6b7280',
    marginBottom: 20,
  },
  sectionTitle: {
    fontSize: 13,
    fontFamily: 'Helvetica-Bold',
    color: '#1f2937',
    marginBottom: 8,
    marginTop: 16,
  },
  sectionTitleGreen: {
    fontSize: 13,
    fontFamily: 'Helvetica-Bold',
    color: '#16a34a',
    marginBottom: 8,
    marginTop: 16,
  },
  sectionTitleRed: {
    fontSize: 13,
    fontFamily: 'Helvetica-Bold',
    color: '#dc2626',
    marginBottom: 8,
    marginTop: 16,
  },
  listItem: {
    fontSize: 10,
    color: '#374151',
    marginBottom: 4,
    paddingLeft: 12,
  },
  italicListItem: {
    fontSize: 10,
    color: '#374151',
    marginBottom: 4,
    paddingLeft: 12,
    fontStyle: 'italic',
  },
  numberedItem: {
    fontSize: 10,
    color: '#374151',
    marginBottom: 4,
    paddingLeft: 12,
  },
  templateBox: {
    backgroundColor: '#f3f4f6',
    padding: 12,
    marginTop: 8,
    borderRadius: 4,
  },
  templateText: {
    fontSize: 10,
    fontStyle: 'italic',
    color: '#374151',
  },
  footer: {
    position: 'absolute',
    bottom: 32,
    left: 48,
    right: 48,
    borderTop: '1pt solid #e5e7eb',
    paddingTop: 8,
  },
  footerText: {
    fontSize: 8,
    color: '#9ca3af',
  },
});

interface GuidePdfProps {
  guide: Guide;
}

export function GuidePdf({ guide }: GuidePdfProps) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text style={styles.brand}>Metaonia</Text>
          <Text style={styles.headerSubtext}>Accommodation Guide for Managers</Text>
        </View>

        <Text style={styles.title}>{guide.title}</Text>
        <Text style={styles.situation}>{guide.situation}</Text>

        <Text style={styles.sectionTitleGreen}>What to Say</Text>
        {guide.whatToSay.map((phrase, i) => (
          <Text key={i} style={styles.italicListItem}>
            {'\u2022'} &quot;{phrase}&quot;
          </Text>
        ))}

        <Text style={styles.sectionTitleRed}>What NOT to Say</Text>
        {guide.whatNotToSay.map((phrase, i) => (
          <Text key={i} style={styles.italicListItem}>
            {'\u2022'} &quot;{phrase}&quot;
          </Text>
        ))}

        <Text style={styles.sectionTitle}>Practical Steps</Text>
        {guide.practicalSteps.map((step, i) => (
          <Text key={i} style={styles.numberedItem}>
            {i + 1}. {step}
          </Text>
        ))}

        <Text style={styles.sectionTitle}>Follow-up Template</Text>
        <View style={styles.templateBox}>
          <Text style={styles.templateText}>&quot;{guide.followUpTemplate}&quot;</Text>
        </View>

        <View style={styles.footer}>
          <Text style={styles.footerText}>
            Metaonia Accommodation Guide — {guide.title}
          </Text>
        </View>
      </Page>
    </Document>
  );
}
